import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { not_implemented_type } from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { DTO__special_collections_info } from '@shared/dto/collection/DTO__special_collections_info';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { get_or_create_special_collection_info_by_workspace_id } from '../_methods/get_or_create_special_collection_info_by_workspace_id';
import { STATE__collections } from '../STATE__collections';

export const LOCAL__collection_cells_delete = (items: DTO__grid2d_cell[]): PayloadAction<DTO__grid2d_cell[]> => ({
  type: ENUM__redux_action.COLLECTION_CELLS_DELETE,
  payload: items,
});

export function INIT_LOCAL__collection_cells_delete(state: STATE__collections, action: PayloadAction<DTO__grid2d_cell[]>) {
  let items = action.payload;

  if (items.is_empty()) return;

  for (let item of items) {
    let special_collection_info = get_or_create_special_collection_info_by_workspace_id(state, item.workspace_id);
    special_collection_info = try_delete_cell_from_special_collection(special_collection_info, item);
    state.special_collections_info_map.set(item.workspace_id, special_collection_info);

    state.special_collections_info_current = try_delete_cell_from_special_collection(special_collection_info, item);
  }

  //need to force a re-render
  state.special_collections_info_map = new Map(state.special_collections_info_map);
}

function try_delete_cell_from_special_collection(special_collection_info: DTO__special_collections_info, item: DTO__grid2d_cell) {
  if (special_collection_info.workspace_id != item.workspace_id) return special_collection_info;

  let out = special_collection_info.clone();

  let { grid2d_type } = item;

  switch (grid2d_type) {
    case ENUM__workspace_entity.COLLECTION_FAVORITES: {
      out.images_ids_favorites.delete(item.hash_sha256_content);
      break;
    }
    case ENUM__workspace_entity.COLLECTION_VIEWED_ON_SEARCH: {
      out.images_ids_viewed_on_search.delete(item.hash_sha256_content);
      break;
    }
    case ENUM__workspace_entity.COLLECTION_CUSTOM:

    case ENUM__workspace_entity.COLLECTION_UPLOADS:
    case ENUM__workspace_entity.COLLECTION_GENERATED:

    case ENUM__workspace_entity.ENTITY_USER_TASK:
    case ENUM__workspace_entity.ENTITY_GENERATION:
    case ENUM__workspace_entity.ENTITY_SEARCH:
      //do nothing
      break;

    default:
      not_implemented_type(grid2d_type);
  }

  return out;
}
